import { Link } from "react-router-dom";
function Biologylab() {
  return (
    <>
      <div className="innerslide py-3 bg-light border-bottom">
        <ul className="breadcrumb container mb-0">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>
          <li className="breadcrumb-item"> Facilities</li>
          <li className="breadcrumb-item active">Biology Lab</li>
        </ul>
      </div>
      <div className="innersec container my-5">
        <div className="row g-3 facilities_section_imgs">
          <div class="col-lg-12">
            <h1> Biology Lab </h1>
            <p>
              A Biology Lab typically provides hands-on experience with
              essential biological techniques, including proper laboratory
              safety, microscope use, cell and tissue observation, DNA and
              enzyme experiments, microbial culturing, and basic physiological
              investigations, while emphasizing accurate data collection,
              analysis, and scientific reasoning.
            </p>
          </div>
        </div>
        <br />

        <div className="row g-3 facilities_section_imgs">
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
            <img
              src="https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/Biology_1.jpg"
              alt="Frank Anthony Bangalore"
              className="img-fluid"
            />
          </div>

          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
            <img
              src="https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/Biology_2.jpg"
              alt="Frank Anthony Bangalore"
              className="img-fluid"
            />
          </div>
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
            <img
              src="https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/Biology_3.jpg"
              alt="Frank Anthony Bangalore"
              className="img-fluid"
            />
          </div>
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
            <img
              src="https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/Biology_4.jpg"
              alt="Frank Anthony Bangalore"
              className="img-fluid"
            />
          </div>
        </div>
      </div>
    </>
  );
}
export default Biologylab;
